import { useCallback, useMemo, useState } from 'react';

import { DEFAULT_CURRENCY, setActiveCurrency, SUPPORTED_CURRENCIES } from '../utils/formatters.js';
import { CurrencyContext } from './useCurrency.js';

const STORAGE_KEY = 'recica.currency';

function readStoredCurrency() {
  if (typeof window === 'undefined') {
    return DEFAULT_CURRENCY;
  }
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return SUPPORTED_CURRENCIES.includes(stored) ? stored : DEFAULT_CURRENCY;
}

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(readStoredCurrency);

  // Keep the formatter's module-level currency in sync with the active value so
  // that formatCurrency()/formatNumber() render in the selected currency.
  setActiveCurrency(currency);

  const setCurrency = useCallback((next) => {
    if (!SUPPORTED_CURRENCIES.includes(next)) {
      return;
    }
    window.localStorage.setItem(STORAGE_KEY, next);
    setActiveCurrency(next);
    setCurrencyState(next);
  }, []);

  const value = useMemo(
    () => ({ currency, setCurrency, supportedCurrencies: SUPPORTED_CURRENCIES }),
    [currency, setCurrency],
  );

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}
